<template>
  <div>
    <div class="app-title">
      <em-view-title :key="modelName+'viewTitle'" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="entityResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName"
                        withCustomRowActions exportDisabled
                        ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoDetail(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";

export default {
  name: "SithMesQualityInspectTemplateList",
  mixins: [emCommonListMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed:{
    modelName(){
      return 'sithMesQualityInspectTemplate'
    }
  },
  methods:{
    gotoDetail(row) {
      this.$router.push('/sithMes/quality/sithMesQualityInspectTemplate/saveTemplate?templateId=' + row.id);
    }
  }
}

</script>

<style scoped>

</style>